/* unplugin-vue-components disabled */import script from "./FloatingAssistantFab.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingAssistantFab.vue?vue&type=script&setup=true&lang=js"

import "./FloatingAssistantFab.vue?vue&type=style&index=0&id=1992d650&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1992d650"]])

export default __exports__